export default __webpack_public_path__ + "e8f9e422773d82356de2b40cd45e249b.svg";